export const normalizePromoCode = (code) => code?.trim().toUpperCase() || '';

// Request order matters because the response maps priced rows back to cart positions.
// `paymentMethod` is a hint: 'ach' quotes the bank discount for an eligible account and is
// ignored for everyone else, so the quote and the charge come from the same price object.
export const orderPriceRequest = (items, countryCode, shippingType = -1, promoCode = '', paymentMethod) => ({
  products: items.map((item) => {
    const product = { id: item.productId, pages_count: item.data?.pages?.length };
    return item.bundle
      ? { id: item.bundle.id, quantity: item.quantity, products: [product] }
      : { ...product, quantity: item.quantity };
  }),
  country_alpha2: countryCode,
  shipping_type: shippingType === -1 ? undefined : shippingType,
  promo_code: normalizePromoCode(promoCode) || undefined,
  payment_method: paymentMethod || undefined,
});
